import { render, staticRenderFns } from "./MedicationProfileDialog.vue?vue&type=template&id=2e57eb40&scoped=true"
import script from "./MedicationProfileDialog.vue?vue&type=script&lang=js"
export * from "./MedicationProfileDialog.vue?vue&type=script&lang=js"
import style0 from "./MedicationProfileDialog.vue?vue&type=style&index=0&id=2e57eb40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e57eb40",
  null
  
)

export default component.exports